import React from 'react';
import { ClockIcon, SearchIcon } from 'lucide-react';
type QA = {
  q: string;
  a: string;
};
type ProblemCardProps = {
  variant: 'blue' | 'gold' | 'navy';
  title: string;
  paragraphs: string[];
  list?: string[];
  qa?: QA[];
  outro?: string[];
  highlight: string;
};
const styles = {
  blue: {
    card: 'border border-slate-200 border-l-[5px] border-l-teal-700 bg-white',
    title: 'text-blue-950',
    body: 'text-slate-600',
    hl: 'text-teal-700',
    bullet: 'bg-teal-700',
    q: 'text-blue-950'
  },
  gold: {
    card: 'border border-slate-200 border-l-[5px] border-l-amber-400 bg-white',
    title: 'text-blue-950',
    body: 'text-slate-600',
    hl: 'text-amber-700',
    bullet: 'bg-amber-400',
    q: 'text-blue-950'
  },
  navy: {
    card: 'bg-blue-950',
    title: 'text-white',
    body: 'text-blue-200',
    hl: 'text-amber-400',
    bullet: 'bg-amber-400',
    q: 'text-white'
  }
};
export function ProblemCard({
  variant,
  title,
  paragraphs,
  list,
  qa,
  outro,
  highlight
}: ProblemCardProps) {
  const s = styles[variant];
  const Icon = variant === 'gold' ? ClockIcon : variant === 'navy' ? SearchIcon : null;
  const textCls = `text-[14px] leading-[1.45] md:text-[15px] ${s.body}`;
  return <article className={`rounded-md px-4 py-3.5 md:px-5 md:py-4 ${s.card}`} data-id="element-155" data-mp="152x2l5rfmohw">
      <h2 className={`text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] md:text-[24px] ${s.title}`} data-id="element-156" data-mp="103twdhzpuc8c">
        {Icon && <Icon className="mr-2 inline h-5 w-5 -translate-y-0.5 text-amber-400 md:h-6 md:w-6" strokeWidth={2.5} aria-hidden data-id="element-157" data-mp="1wsrt35r10k85" />}
        {title}
      </h2>
      {paragraphs.length > 0 && <div className={`mt-1.5 space-y-1.5 ${textCls}`} data-id="element-158" data-mp="1nrbq3j2jjkdy">
          {paragraphs.map(p => <p key={p} data-id="element-159" data-mp="1isqpvjnah0pi">{p}</p>)}
        </div>}
      {list && <ul className={`mt-2 space-y-1 ${textCls}`} data-id="element-160" data-mp="cdq426rz9ywn">
          {list.map(item => <li key={item} className="flex gap-2" data-id="element-161" data-mp="7du0g8n709hm">
              <span className={`mt-[0.55em] h-1.5 w-1.5 shrink-0 rounded-full ${s.bullet}`} aria-hidden data-id="element-162" data-mp="7d242vlru7qa" />
              <span data-id="element-163" data-mp="8tfvbly67at8">{item}</span>
            </li>)}
        </ul>}
      {qa && <dl className={`mt-2 space-y-2 ${textCls}`} data-id="element-164" data-mp="dsj2pd1mht4d">
          {qa.map(item => <div key={item.q} data-id="element-165" data-mp="3vzqbbelkt24j">
              <dt className={`text-[13px] font-bold leading-snug md:text-[14px] ${s.q}`} data-id="element-166" data-mp="4txbkti355rz">{item.q}</dt>
              <dd className="mt-0.5" data-id="element-167" data-mp="3maf6w59mwlmz">{item.a}</dd>
            </div>)}
        </dl>}
      {outro && <div className={`mt-2 space-y-1.5 ${textCls}`} data-id="element-168" data-mp="3r1ovr3nczkxt">
          {outro.map(p => <p key={p} data-id="element-169" data-mp="3da0j8z976ugb">{p}</p>)}
        </div>}
      <p className={`mt-2 text-[12px] font-extrabold uppercase leading-tight md:text-[14px] ${s.hl}`} data-id="element-170" data-mp="3dbld0mnou9d4">
        {highlight}
      </p>
    </article>;
}